import { useState, useEffect } from 'react';
import { gql, useMutation } from '@apollo/client';
import { UPDATE_USER } from 'apollo/mutations/Client';

export const useNotificationSettings = (user) => {
  const [selectedOption, setSelectedOption] = useState('');
  const [updateUser] = useMutation(gql(UPDATE_USER));

  useEffect(() => {
    if (user?.notification) {
      setSelectedOption(user.notification);
    }
  }, [user]);

  const handleOptionChange = async (event) => {
    setSelectedOption(event.target.value);
    await updateUser({
      variables: {
        input: {
          notification: event.target.value,
        },
      },
      refetchQueries: ['ClientQuery'],
    });
  };

  return { selectedOption, handleOptionChange };
};
